import { render } from "./Card1.vue?vue&type=template&id=4f3db4b7"
import script from "./Card1.vue?vue&type=script&lang=ts"
export * from "./Card1.vue?vue&type=script&lang=ts"
script.render = render

export default script